
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  const rotaDisponibilidadeMeses =
    req.url.includes('/api/disponibilidade-meses');

  const rotaRegrasMinimoNoites =
    req.method === 'GET' &&
    req.url.includes('/api/regras-minimo-noites');

  const rotaPublica =
    (req.method === 'GET' && req.url.includes('/api/quartos')) ||
    req.url.includes('/api/auth/login') ||
    (req.method === 'GET' && req.url.includes('/api/reservas/calendario')) ||
    (req.method === 'GET' && req.url.includes('/api/reservas/') && req.url.includes('/checkout/cartao/opcoes')) ||
    (req.method === 'GET' && req.url.includes('/api/reservas/disponibilidade')) ||
    (req.method === 'GET' && req.url.includes('/api/reservas/') && req.url.includes('/pagamento/status')) ||
    (req.method === 'POST' && req.url.endsWith('/api/reservas')) ||
    (req.method === 'POST' && req.url.includes('/api/reservas/') && req.url.endsWith('/checkout/cartao')) ||
    (req.method === 'POST' && req.url.includes('/api/reservas/') && req.url.endsWith('/checkout')) ||
    (req.method === 'GET' && req.url.includes('/api/avaliacoes/')) ||
    rotaRegrasMinimoNoites;

  // Rotas públicas: remove qualquer Authorization existente.
  if (rotaPublica && !rotaDisponibilidadeMeses) {
    const requestPublica = req.clone({
      headers: req.headers.delete('Authorization')
    });

    return next(requestPublica);
  }

  // Sem token: segue sem autenticação.
  if (!token || !token.trim()) {
    return next(req);
  }

  const tokenLimpo = token
    .replace(/^Bearer\s+/i, '')
    .trim();

  const requestAutenticada = req.clone({
    setHeaders: {
      Authorization: `Bearer ${tokenLimpo}`
    }
  });

  return next(requestAutenticada);
};
